import global from '@/core/global/global.js'
var url='main';
export default [{
    path: '/',
    component: resolve => require(['@/views/home'], resolve),
    children: [
      {
        path: 'index',
        meta: {
          title: '共战疫情'
        },
        component: resolve => require([`@/views/${url}/index`], resolve),
      },
      {
        path: 'list',
        component: resolve => require([`@/views/${url}/list`], resolve),
      },
      {
        path: 'detail',
        component: resolve => require([`@/views/${url}/detail`], resolve),
      },
      {
        path: 'single',
        component: resolve => require([`@/views/${url}/single`], resolve),
      },
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/main_routers.js